import React from 'react';
import { IconInbox } from '@bynder/icons';
import { MetapropertiesOption } from '../../../../types';
import { iconSizeExtraLarge } from '../../../../helpers/iconSizes';

type Props = {
	defaultSearchAction: (
		isMPOSearch?: boolean,
		metapropertyName?: string,
		metapropertyOptionName?: string,
		metapropertyOptionLabel?: string,
	) => void;
	spotlightFilterAction?: string;
	metapropertyOption: MetapropertiesOption;
	metapropertyName: string;
	clearSearchTerm: () => void;
};

export default function GroupMetapropertiesOptions({
	metapropertyOption: { id, name, label, image, description },
	defaultSearchAction,
	metapropertyName,
	spotlightFilterAction,
	clearSearchTerm,
}: Props) {
	const onMetapropertyOptionClick = () => {
		if (spotlightFilterAction === 'pim') {
			document.location.href = `/show/${metapropertyName}/${id}`;
		} else {
			defaultSearchAction(true, metapropertyName, name, label);
			clearSearchTerm();
		}
	};

	return (
		<li
			className="spotlight-meta-property-option"
			data-id={id}
			data-name={name}
			data-label={label}
		>
			<a href="#" onClick={onMetapropertyOptionClick}>
				<div className="searchbox-img">
					{image && image.length > 0 ? (
						<img alt={label} src={image} />
					) : (
						<IconInbox size={iconSizeExtraLarge} />
					)}
				</div>
				<p className="searchbox-title">{label}</p>
				{description && <p className="searchbox-description">{description}</p>}
			</a>
		</li>
	);
}
